import { createListLocate } from '@/lib/notifications/create-list-locate.js';

/**
 * Attach locateRowInList to an integration instance when missing.
 */
export function bindIntegrationLocate(integration, config) {
    if (!integration || integration.locateRowInList) {
        return integration;
    }
    integration.locateRowInList = createListLocate(config);
    return integration;
}

/** @param {{ integration: object, useStore: import('zustand').UseBoundStore<any>, getItems?: Function, getRowId?: Function, fetchList: Function, service?: object, defaultSortBy?: string, defaultSortOrder?: string, extraQuery?: object }} spec */
export function wireIntegrationLocate({
    integration,
    useStore,
    getItems = (s) => s.items,
    getRowId,
    fetchList,
    service,
    defaultSortBy = '',
    defaultSortOrder = 'desc',
    extraQuery = {},
}) {
    return bindIntegrationLocate(integration, {
        service: service ?? integration?.service,
        useStore,
        getItems,
        getRowId,
        fetchList,
        defaultSortBy,
        defaultSortOrder,
        extraQuery,
    });
}
